import { Box } from "../../box";
import { Button } from "../../button";
import { useCollection } from "../../collection";
import { forwardRef } from "react";
import { isNil, mergeProps, useEventCallback } from "../../shared";
import { Tag } from "./Tag";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";

function TagItem({
  item,
  onRemove,
  readOnly,
  size,
  ...rest
}) {
  const handleRemove = useEventCallback(event => {
    if (!isNil(onRemove)) {
      onRemove(event, item.key);
    }
  });
  return /*#__PURE__*/_jsx(Tag, { ...mergeProps(item.props, rest, {
      className: "o-ui-tag-list-item",
      onRemove: !readOnly ? handleRemove : undefined,
      size,
      variant: "outline"
    }),
    children: item.content
  });
}

export function InnerTagList({
  as = DefaultElement,
  children,
  forwardedRef,
  onClear,
  onRemove,
  readOnly,
  size,
  ...rest
}) {
  const nodes = useCollection(children);

  const clearButtonMarkup = !isNil(onClear) && !readOnly && nodes.length > 0 && /*#__PURE__*/_jsx(Button, {
    className: "o-ui-tag-list-clear-button",
    onClick: onClear,
    size: size,
    variant: "tertiary",
    children: "Clear all"
  });

  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: "o-ui-tag-list",
      ref: forwardedRef
    }),
    children: [nodes.map(x => /*#__PURE__*/_jsx(TagItem, {
      item: x,
      onRemove: onRemove,
      readOnly: readOnly,
      size: size
    }, x.key)), clearButtonMarkup]
  });
}
InnerTagList.defaultElement = DefaultElement;
export const TagList = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerTagList, { ...props,
  forwardedRef: ref
}));